import {
  collectionArticleRequest,
  copyCollectionRequest,
  copyCollectionResponse,
  createCollectionRequest,
  createCollectionResponse,
  deleteCollectionRequest,
  getArticleCollectionsRequest,
  getArticleCollectionsResponse,
  getBookmarkedArticlesResponse,
  listCollectionsResponse,
  putCollectionArticleResponse,
  updateCollectionRequest,
} from "./collections.dto";
import { apiV2 } from "./v2";

export const listCollectionsApi = apiV2("GET", "/collections").withResponse(listCollectionsResponse);

export const createCollectionApi = apiV2("POST", "/collections").withRequest(createCollectionRequest).withResponse(createCollectionResponse);

export const updateCollectionApi = apiV2("PUT", "/collections/:id").withRequest(updateCollectionRequest);

export const deleteCollectionApi = apiV2("DELETE", "/collections/:id").withRequest(deleteCollectionRequest);

export const copyCollectionApi = apiV2("POST", "/collections/:id/copy").withRequest(copyCollectionRequest).withResponse(copyCollectionResponse);

export const putCollectionArticleApi = apiV2("PUT", "/collections/:id/articles/:alias/:articleId")
  .withRequest(collectionArticleRequest)
  .withResponse(putCollectionArticleResponse);

export const removeCollectionArticleApi = apiV2("DELETE", "/collections/:id/articles/:alias/:articleId").withRequest(collectionArticleRequest);

export const getArticleCollectionsApi = apiV2("GET", "/articles/:alias/:articleId/collections")
  .withRequest(getArticleCollectionsRequest)
  .withResponse(getArticleCollectionsResponse);

export const getBookmarkedArticlesApi = apiV2("GET", "/user/articles/bookmarked").withResponse(getBookmarkedArticlesResponse);
